//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 
import UMUM         from "../../library/umum"        ;
import WILAYAH      from "../../library/getWilayah"  ;
import CHART        from '../../library/chart'       ;
import FETCHING     from '../../library/fetching'    ;


export default {
  data() {
    return {
      form : {
        id : '',
        des_kel : this.$store.state.ID_DES_KEL,
        tahun : '',
      },
     
      list_data : [],
      cek_load_data : true, 

      listKegiatan: [],

      page_limit: 1000,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,

      UMUM: UMUM
    };
  },
  methods: {
    getView : async function(){
      var body = this.form
      this.list_data = await FETCHING.postDataPublish(this.$store.state.url.URL_CNT_KECAMATAN_KECAMATAN, 'PotensiWilayah', body);
      console.log(this.list_data)
    },

    chartnya : async function(){
      var body = this.form
      var dataArray = await CHART.postData(this.$store.state.url.URL_CNT_KECAMATAN_DASHBOARD, 'PotensiWilayah', body);
      console.log(dataArray)
      CHART.BarChart('barchartnya', 'Potensi Wilayah', 'Data Potensi Wilayah', dataArray.uraian, dataArray.jumlah)
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
            this.chartnya();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        }




    // ====================================== PAGINATE ====================================
  },
  mounted() {

    const d = new Date();
    this.form.tahun = d.getFullYear();
    console.log(this.form.tahun)

    console.log("AAAAAAAAAAAAAAAAA")

    this.form.des_kel = this.$store.state.ID_DES_KEL
    this.$store.state.kegiatan.id = this.$route.query.id;
    WILAYAH.getListDesKelFull();
    this.cari_data();
  }
};
